// extracted by mini-css-extract-plugin
var _1 = "CalendarGridAgendaRow-moduleCalendarGridAgendaRow__Vwkmz";
export { _1 as "CalendarGridAgendaRow" }
